class PriceTab {
  constructor(el) {
    this.root = document.querySelector('.' + el);
    if (!this.root) return;
    this.event();
  }

  event() {
    const tabs = this.root.querySelectorAll('[data-price-tab]');
    const panels = this.root.querySelectorAll('[data-price-panel]');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.priceTab;

        tabs.forEach((item) => {
          const isActive = item.dataset.priceTab === target;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach((panel) => {
          const isActive = panel.dataset.pricePanel === target;
          panel.classList.toggle('hidden', !isActive);
          panel.hidden = !isActive;
        });
      });
    });
  }
}
